import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import servicioObjetos from '../servicio/ServicioObjetos';
import { Calendar } from "primereact/calendar";
import { TabView, TabPanel } from "primereact/tabview";
import { TabMovimientosTrabajadorSua } from './TabMovimientosTrabajadorSua';
import { TabImportarDatos } from './TabImportarDatos';
import servicioHttp from '../servicio/ServicioHttp';
import ServicioArchivos from '../servicio/ServicioArchivos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
import { Lightbox } from 'primereact/lightbox';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';

const JOIN_PRINCIPAL = {
    "ttPatron": "alias_ttPatron",
    "ttRegistroPatronal": "alias_ttRegistroPatronal"
};

export class AltaTrabajadoresManualSua extends Component {
    constructor() {
        super();
        this.state = {
            criterio: {},
            consulta: {},
            movimientos: [],
            iFrameSrc: null,
            registrosPatronales: [],
            rfcEmpresas: [],
            mostrarModalConfirmacion: false,
            mostrarModalConfirmacioActualizar: false,
            mostrarModalConfirmacionCredito: false,
            paginacion: { registrosPorPagina: 20 },
            idsenube: 0,
            trabajador: {},
            errores: {},
            criteriosOrdenamientos: [{ label: "Número seguridad social", value: "numeroSeguridadSocial" }, { label: "Nombre", value: "primerApellido" }, { label: "Clave Ubicación", value: "claveUbicacion" }],

            tiposTrabajadores: [
                { label: "* Tipo trabajador", value: null },
                { label: "Permanente", value: "1" },
                { label: "Eventual", value: "2" },
                { label: "Contrucción", value: "3" },
                { label: "Campo", value: "4" },
            ],
            jornadas: [
                { label: "* Tipo Jornada", value: null },
                { label: "Normal", value: "0" },
                { label: "Semana Completa", value: "Semana Completa" },
                { label: "1 Día", value: "1 Día" },
                { label: "2 Días", value: "2 Días" },
                { label: "3 Días", value: "3 Días" },
                { label: "4 Días", value: "4 Días" },
                { label: "5 Días", value: "5 Días" },
                { label: "Menor a 8 Horas", value: "Menor a 8 Horas" },
            ],
            tipoTrabajadorPensionados: [
                { label: "* Tipo Trabajador Pensionado", value: null },
                { label: "Sin Pensión", value: "0" },
                { label: "Pensión IV", value: "1" },
                { label: "Pensión CV", value: "2" },

            ],
            sexos: [
                { label: "* Sexo", value: null },
                { label: "Masculino", value: "M" },
                { label: "Femenino", value: "F" },


            ],
            tiposSalarios: [
                { label: "* Tipo salario", value: null },
                { label: "Fijo", value: "0" },
                { label: "Variable", value: "1" },
                { label: "Mixto", value: "2" },


            ],
            lugaresNacimiento: [
                { label: "Lugar nacimiento", value: null },
                { label: "AGUASCALIENTES", value: "AGUASCALIENTES" },
                { label: "BAJA CALIFORNIA NORTE", value: "BAJA CALIFORNIA NORTE" },
                { label: "BAJA CALIFORNIA SUR", value: "BAJA CALIFORNIA SUR" },
                { label: "CAMPECHE", value: "CAMPECHE" },
                { label: "CHIAPAS", value: "CHIAPAS" },
                { label: "CHIHUAHUA", value: "CHIHUAHUA" },
                { label: "COAHUILA", value: "COAHUILA" },
                { label: "COLIMA", value: "COLIMA" },
                { label: "DISTRITO FEDERAL", value: "DISTRITO FEDERAL" },
                { label: "DURANGO", value: "DURANGO" },
                { label: "ESTADO DE MEXICO", value: "ESTADO DE MEXICO" },
                { label: "GUANAJUATO", value: "GUANAJUATO" },
                { label: "GUERRERO", value: "GUERRERO" },
                { label: "HIDALGO", value: "HIDALGO" },
                { label: "JALISCO", value: "JALISCO" },
                { label: "MICHOACAN", value: "MICHOACAN" },
                { label: "MORELOS", value: "MORELOS" },
                { label: "NAYARIT", value: "NAYARIT" },
                { label: "NUEVO LEON", value: "NUEVO LEON" },
                { label: "OAXACA", value: "OAXACA" },
                { label: "PUEBLA", value: "PUEBLA" },
                { label: "QUERETARO", value: "QUERETARO" },
                { label: "QUINTANA ROO", value: "QUINTANA ROO" },
                { label: "SAN LUIS POTOSI", value: "SAN LUIS POTOSI" },
                { label: "SINALOA", value: "SINALOA" },
                { label: "SONORA", value: "SONORA" },
                { label: "TABASCO", value: "TABASCO" },
                { label: "TAMAULIPAS", value: "TAMAULIPAS" },
                { label: "TLAXCALA", value: "TLAXCALA" },
                { label: "VERACRUZ", value: "VERACRUZ" },
                { label: "YUCATAN", value: "YUCATAN" },
                { label: "ZACATECAS", value: "ZACATECAS" },
                { label: "EXTRANJEROS", value: "EXTRANJEROS" },
            ],
            mostrarCatalogoTrabajadores: false,
            desactivarDatosAfiliatorios: true,
            desactivarMovimientos: true,
            desactivarImportarDatos: false,
            desactivarBotonesImportar: true,
        }
    }

    componentDidMount() {
        this.obtenerRfcEmpresa();

        this.activarTabs(0);
    }
    obtenerRfcEmpresa = () => {
        servicioHttp.consumirPostHttp('/patron/obtener_rfc.json').then(response => {
            this.setState({ rfcEmpresas: response.data.lista });
        }).catch(error => {
        });
    }
    obtenerRegistroPatronal = () => {
        let { trabajador } = this.state;
        let ttPatron = {};
        ttPatron.id = trabajador.ttPatron;
        servicioHttp.consumirPostHttp('/registropatronal/obtener_registro_patronal.json', ttPatron).then(response => {
            this.setState({ registrosPatronales: response.data.lista });
        }).catch(error => {
        });
    }
    obtenerRegistroPatronalPreditar = (ttPatron) => {
        servicioHttp.consumirPostHttp('/registropatronal/obtener_registro_patronal.json', ttPatron).then(response => {
            this.setState({ registrosPatronales: response.data.lista });
        }).catch(error => {
        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerResultados();
    }



    obtenerResultados = () => {
        let { paginacion, trabajador, consulta, criterio } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        let id = trabajador.ttPatron;
        let idRegistro = trabajador.ttRegistroPatronal;
        if (id !== undefined && idRegistro !== undefined) {
            paginacion.restriccionesDinamicas = [];

            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.id",
                valorPropiedad: id,
            });
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttRegistroPatronal.id",
                valorPropiedad: idRegistro,
            });

            if (!servicioObjetos.esObjetoVacio(consulta.numeroSeguridadSocial)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "numeroSeguridadSocial",
                    valorPropiedad: consulta.numeroSeguridadSocial,
                });
            }
            if (!servicioObjetos.esObjetoVacio(consulta.claveUbicacion)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "claveUbicacion",
                    valorPropiedad: consulta.claveUbicacion,
                });
            }
            if (!servicioObjetos.esObjetoVacio(consulta.numeroCredito)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "numeroCredito",
                    valorPropiedad: consulta.numeroCredito,
                });
            }


            if (!servicioObjetos.esObjetoVacio(consulta.nombre)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "like",
                    modoLike: "START",
                    nombrePropiedad: "primerApellido",
                    valorPropiedad: consulta.nombre,
                });
            }
            if (!servicioObjetos.esObjetoVacio(criterio.descripcion)) {
                paginacion.ordenamientos = [];
                paginacion.ordenamientos.push({
                    tipo: 'asc',
                    nombrePropiedad: criterio.descripcion
                });
            }
            servicioHttp.consumirPostHttp("/trabajador_sua/consulta.json", paginacion).then((response) => {
                this.setState({
                    paginacion: response.data.objeto,
                    mostrarCatalogoTrabajadores: true
                });
                // this.growl.show({ severity: 'success', summary: '', detail: response.data.mensage });
            }).catch(() => { });
        } else {
            this.growl.show({ severity: 'error', summary: '', detail: "selecciona un RFC de empresa y un Registro patronal" });
        }
    }
    asignarValores = (event, mayusculas, acentos) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas, acentos);
        let idElemento = event.target.id;        
        if (idElemento === "criterio.descripcion") {
            this.obtenerResultados();
        }


    };
    validarTipoTrabajador = (e, mayusculas) => {
        this.asignarValores(e, mayusculas);
    }
    obtenerRP = (e, mayusculas) => {
        this.asignarValores(e, mayusculas);
        this.obtenerRegistroPatronal();
    }
    validarNss = () => {
        let { trabajador } = this.state;
        let id = trabajador.ttPatron;
        let idRegistro = trabajador.ttRegistroPatronal;
        let ttRegistroPatronal = {};
        ttRegistroPatronal.id = trabajador.ttRegistroPatronal;
        trabajador.ttRegistroPatronal = ttRegistroPatronal;
        let ttPatron = {};
        ttPatron.id = trabajador.ttPatron;
        trabajador.ttPatron = ttPatron;
        servicioHttp.consumirPostHttp('trabajador_sua/validar_nss.json', trabajador).then(response => {
            if (response.data.error) {
                this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.mensaje, life: 3000 });
                this.reiniciarValores();
            }
            trabajador.ttRegistroPatronal = idRegistro;
            trabajador.ttPatron = id;

        }).catch(error => {

        });

    }
    btnNoReingreso = () => {
        let { trabajador } = this.state;
        trabajador.aplicaCredito = false;
        this.btnActualizar();

    }
    btnActualizar = () => {
        let { trabajador } = this.state;
        let errores = this.validarFormulario(trabajador);
        this.setState({ errores: errores });
        let id = trabajador.ttPatron;
        let idRegistro = trabajador.ttRegistroPatronal;
        if (servicioObjetos.esObjetoVacio(errores)) {
            let ttRegistroPatronal = {};
            ttRegistroPatronal.id = trabajador.ttRegistroPatronal;
            trabajador.ttRegistroPatronal = ttRegistroPatronal;
            let ttPatron = {};
            ttPatron.id = trabajador.ttPatron;
            trabajador.ttPatron = ttPatron;
            if (trabajador.id === undefined) {
                let movimiento = {};
                movimiento.tipoMovimiento = "01";
                movimiento.sdi = trabajador.salarioDiarioIntegrado;
                movimiento.fecha = trabajador.fechaAlta;
                trabajador.movimientos = [
                    movimiento
                ];

            }
            //trabajador.movimiento.articulo33=null;
            servicioHttp.consumirPostHttp('trabajador_sua/guardar.json', trabajador).then(response => {

                if (response.data.error === true) {
                    trabajador.ttPatron = id;
                    trabajador.ttRegistroPatronal = idRegistro;
                    if (response.data.mensaje === "credito") {
                        this.setState({ mostrarModalConfirmacionCredito: true });
                        trabajador.aplicaCredito = true;
                    } else {
                        this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
                        this.cerrarModalsMostrarModalConfirmacioActualizar();
                    }
                } else {
                    this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
                    this.reiniciarValores();
                    trabajador.ttPatron = id;
                    trabajador.ttRegistroPatronal = idRegistro;
                    this.setState({ trabajador });
                }

            }).catch(error => {
                trabajador.ttPatron = id;
                trabajador.ttRegistroPatronal = idRegistro;
                this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Error en el servidor", life: 3000 });
            });
        }
    }
    btnNuevo = () => {
        this.reiniciarValores();
    }
    btnImprimir = () => {
        this.tabImportarDatos.imprimirPdf();
    }
    validarFormulario = (trabajador) => {
        let errores = {};
        var expreReg = /^(\d{2})(-)(\d{2})(-)(\d{2})(-)(\d{4})(-)\d{1}$/;
        var validacionNss = expreReg.exec(trabajador.numeroSeguridadSocial);
        var expreRfc = /^([A-Z,Ñ,&]{3,4})(-)(\d{6})(-)([A-Z|\d]{3})$/;
        var exprecionCurp = /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/;
        var expresionSalario = /^(\d{1,5})(.)(\d{1,2})$/;
        var validacionSalario = expresionSalario.exec(trabajador.salarioDiarioIntegrado);
        var validacionCurp = exprecionCurp.exec(trabajador.curp);
        if (!validacionCurp)
            errores.curp = "Formato invalido de curp";
        if (!validacionSalario)
            errores.salarioDiarioIntegrado = "El formato es invalido debe de ser 00000.00";

        var validacionRfc = expreRfc.exec(trabajador.rfc);
        if (!validacionRfc)
            errores.rfc = "El formato del numero debe de ser el siguiente HERE-940316-F43";

        if (!validacionNss)
            errores.numeroSeguridadSocial = "El formato del numero debe de ser el siguiente 00-00-00-0000-0";
        if (servicioObjetos.esObjetoVacio(trabajador.ttRegistroPatronal))
            errores.ttRegistroPatronal = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.numeroSeguridadSocial))
            errores.numeroSeguridadSocial = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.fechaAlta))
            errores.fechaAlta = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.rfc))
            errores.rfc = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.curp))
            errores.curp = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.tipoTrabajador))
            errores.tipoTrabajador = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.jornadaSemana))
            errores.jornadaSemana = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.trabajadorPensionado))
            errores.trabajadorPensionado = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.salarioDiarioIntegrado))
            errores.salarioDiarioIntegrado = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.codigoPostal))
            errores.codigoPostal = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(trabajador.fechaNacimiento))
            errores.fechaNacimiento = "Ingrese información requerida";
        if (trabajador.jornadaSemana === "Menor a 8 Horas") {
            if (servicioObjetos.esObjetoVacio(trabajador.horas))
                errores.horas = "Ingrese información requerida";
        }
        if (servicioObjetos.esObjetoVacio(trabajador.sexo))
            errores.sexo = "Ingrese información requerida";

        if (servicioObjetos.esObjetoVacio(trabajador.tipoSalario))
            errores.tipoSalario = "Ingrese información requerida";

        if (servicioObjetos.esObjetoVacio(trabajador.ttPatron))
            errores.ttPatron = "Ingrese información requerida";

        return errores;
    }
    reiniciarValores = () => {
        this.setState({
            trabajador: {},
            errores: {},
            mostrarModalConfirmacion: false,
            mostrarModalConfirmacioActualizar: false,
        });
        this.activarTabs(0);
    }
    prepararEditar = (rowData) => {

        let trabajador = JSON.parse(JSON.stringify(rowData));
        let fechaNacimiento = new Date(trabajador.fechaNacimiento);
        let fechaAlta = new Date(trabajador.fechaAlta);
        let fechaBaja = new Date(trabajador.fechaBaja);
        trabajador.fechaNacimiento = fechaNacimiento;
        trabajador.fechaAlta = fechaAlta;
        trabajador.fechaBaja = fechaBaja;
        trabajador.ttPatron = rowData.idPatron;
        trabajador.ttRegistroPatronal = rowData.idRegistroPatronal;
        this.obtenerRegistroPatronalPreditar({ id: trabajador.ttPatron });
        this.setState({ trabajador: trabajador });
        this.cerrarModalCatalogoTrabajadores();
    }
    preActualizar = () => {
        let { trabajador, activeIndex } = this.state;

        let erroresMovimientos = {};
        if (activeIndex === 1) {
            erroresMovimientos = this.tabMovimientosTrabajadorSua.guardarMovimiento();
        }

        if (servicioObjetos.esObjetoVacio(erroresMovimientos)) {
            let errores = this.validarFormulario(trabajador);
            this.setState({ errores: errores });
            if (servicioObjetos.esObjetoVacio(errores)) {
                this.setState({ mostrarModalConfirmacioActualizar: true });
            }
        }


    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.prepararEditar(rowData)}
                    className="p-button-warning" name="Editar" tooltip="Editar">
                </Button>
            </div>
        </div>;
    }
    mostrarModalEliminar = (rowData) => {
        let { trabajador } = this.state;
        if (servicioObjetos.esObjetoVacio(trabajador.id)) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "debes de seleccionar un trabajador", life: 3000 });
        } else {
            this.setState({ mostrarModalConfirmacion: true });
        }
    }

    cerrarModalConfirmacion = () => {
        this.setState({ mostrarModalConfirmacion: false, mostrarModalConfirmacioActualizar: false, mostrarModalConfirmacionCredito: false });
    }
    eliminarTrabajador = () => {
        let { trabajador } = this.state;
        let ttPatron = {};
        ttPatron.id = trabajador.ttPatron;
        trabajador.ttPatron = ttPatron;
        let ttRegistroPatronal = {};
        ttRegistroPatronal.id = trabajador.ttRegistroPatronal;
        trabajador.ttRegistroPatronal = ttRegistroPatronal;
        servicioHttp.consumirPostHttp('trabajador_sua/eliminar.json', trabajador).then(response => {
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 3000 });
            this.reiniciarValores();
            this.obtenerResultados();
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Error en el servidor", life: 3000 });
        });

    }
    btnReporte = () => {
        let { trabajador } = this.state;
        let ttPatron = {};
        let ttRegistroPatronal = {};
        let id = trabajador.ttPatron;
        let idRegistroPatronal = trabajador.ttRegistroPatronal;
        ttPatron.id = trabajador.ttPatron;
        trabajador.ttPatron = ttPatron;
        ttRegistroPatronal.id = trabajador.ttRegistroPatronal;
        trabajador.ttRegistroPatronal = ttRegistroPatronal;
        if (servicioObjetos.esObjetoVacio(trabajador.numeroSeguridadSocial)) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "debes de seleccionar un trabajador", life: 3000 });
        } else {
            ServicioArchivos.descargaArchivoComoBlob('/trabajador_sua/descargar_documento.json', trabajador)
                .then((response) => {
                    this.setState({ iFrameSrc: URL.createObjectURL(response) });
                    document.getElementById("btnVisorPdfTarget").click();
                    trabajador.ttPatron = id;
                    trabajador.ttRegistroPatronal = idRegistroPatronal;

                }).catch((error) => {
                    console.log(error);
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encutra el archivo' });
                });
            // ServicioArchivos.descargaArchivo('/trabajador_sua/descargar_documento.json');
        }

    }

    dobleClickRenglon = (event) => {
        this.prepararEditar(event.data);
        this.cerrarModalCatalogoTrabajadores();
        this.activarTabs(0);
        setTimeout(() => {
            this.activarTabs(1);
        }, 200);

    }

    cerrarModalCatalogoTrabajadores = () => {
        this.setState({
            mostrarCatalogoTrabajadores: false
        });
    }

    activarTabs = (index) => {
        let desactivarDatosAfiliatorios = false;
        let desactivarMovimientos = true;
        let desactivarImportarDatos = false;
        let desactivarBotonesImportar = true;
        let activeIndex = 0;
        if (index === 0) {
            desactivarDatosAfiliatorios = false;
        }
        if (index === 1) {
            activeIndex = 1;
            desactivarMovimientos = false;
        }
        if (index === 2) {
            activeIndex = 2;
            desactivarImportarDatos = false;
            desactivarBotonesImportar = false;
        }
        this.setState({
            desactivarDatosAfiliatorios: desactivarDatosAfiliatorios,
            desactivarMovimientos: desactivarMovimientos,
            desactivarImportarDatos: desactivarImportarDatos,
            desactivarBotonesImportar: desactivarBotonesImportar,
            activeIndex: activeIndex
        });
    }
    plantillaNombre(rowData, column) {
        return <p >{column.rowData.primerApellido + " " + column.rowData.segundoApellido + " " + column.rowData.nombre}</p>
    }
    buscarPorParametrosTrabajador = () => {
        this.obtenerResultados();

    }
    cerrarModalsMostrarModalConfirmacioActualizar = () => {
        this.setState({ mostrarModalConfirmacioActualizar: false });
    }
    enviarArchivo = () => {
        this.tabImportarDatos.examinar();

    }
    render() {
        const { criterio, criteriosOrdenamientos, desactivarBotonesImportar, mostrarModalConfirmacionCredito, consulta, iFrameSrc, registrosPatronales, mostrarModalConfirmacioActualizar,
            mostrarModalConfirmacion, rfcEmpresas, lugaresNacimiento,
            idsenube, paginacion, tiposSalarios, sexos, activeIndex, trabajador, errores, tiposTrabajadores,
            jornadas, tipoTrabajadorPensionados, mostrarCatalogoTrabajadores,
            desactivarDatosAfiliatorios, desactivarMovimientos, desactivarImportarDatos } = this.state;


        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );
        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminarTrabajador}
                    label="Si estoy seguro" />
                <Button
                    icon="pi-md-close"
                    onClick={this.cerrarModalConfirmacion}
                    label="No estoy seguro"
                    className="p-button-danger flat-btn" />
            </div>
        );


        const dialogFooterConfirmacionActualizar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.btnActualizar}
                    label="Si estoy seguro" />
                <Button
                    icon="pi-md-close"
                    onClick={this.cerrarModalConfirmacion}
                    label="No estoy seguro"
                    className="p-button-danger flat-btn" />
            </div>
        );

        const dialogFooterConfirmacionCredito = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.btnActualizar}
                    label="Si estoy seguro" />
                <Button
                    icon="pi-md-close"
                    onClick={this.btnNoReingreso}
                    label="No estoy seguro"
                    className="p-button-danger flat-btn" />
            </div>
        );

        return (<div>
            <Growl ref={(el) => this.growl = el} />
            <Lightbox target={visorPdfTarget}>
                <div id="contenedorIframe"  >
                    <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" title="pdf"></iframe>
                </div>
            </Lightbox>
            <div className="card">
                <h1>ACTUALIZAR TRABAJADORES</h1>

            </div>
            <div className="card card-w-title">
                <div className="p-grid">
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="trabajador.rfcEmpresa">RFC EMPRESA:</label>
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <Dropdown placeholder="Selecciona empresa" appendTo={document.body} id="trabajador.ttPatron" name="trabajador.ttPatron" options={rfcEmpresas} value={trabajador.ttPatron} onChange={(e) => { this.obtenerRP(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                        {errores.ttPatron ? <div><Message severity="error" text={errores.ttPatron} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="trabajador.registroPatronal">REGISTRO PATRONAL:</label>
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <Dropdown placeholder="Selecciona registro patronal" appendTo={document.body} id="trabajador.ttRegistroPatronal" name="trabajador.ttRegistroPatronal" options={registrosPatronales} value={trabajador.ttRegistroPatronal} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                        {errores.ttRegistroPatronal ? <div><Message severity="error" text={errores.ttRegistroPatronal} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.numeroSeguridadSocial">*NUMERO DE SEGURIDAD SOCIAL:</label>
                    </div>
                    <div className="p-col-12 p-md-2" >
                        <InputText onBlur={this.validarNss} id="trabajador.numeroSeguridadSocial" name="trabajador.numeroSeguridadSocial" style={{ width: "100%" }}
                            value={trabajador.numeroSeguridadSocial || ""} className={errores.numeroSeguridadSocial ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="15" />
                        {errores.numeroSeguridadSocial ? <div><Message severity="error" text={errores.numeroSeguridadSocial} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.fechaAlta">*FECHA DE ALTA</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Calendar id="fechaAlta" name="trabajador.fechaAlta" value={trabajador.fechaAlta}
                            placeholder="* Fecha Alta" onChange={(e) => this.asignarValores(e, false)}
                            className={errores.fechaAlta ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                        {errores.fechaAlta ? <div><br /> <Message severity="error" text={errores.fechaAlta} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.fechaBaja">FECHA DE BAJA</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Calendar id="fechaBaja" name="trabajador.fechaBaja" value={trabajador.fechaBaja}
                            placeholder="Fecha Baja" onChange={(e) => this.asignarValores(e, false)}
                            className={errores.fechaBaja ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                        {errores.fechaBaja ? <div><br /> <Message severity="error" text={errores.fechaBaja} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.rfc">*RFC</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.rfc" name="trabajador.rfc" style={{ width: "100%" }}
                            value={trabajador.rfc || ""} className={errores.rfc ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="16" />
                        {errores.rfc ? <div><Message severity="error" text={errores.rfc} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.curp">*CURP</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.curp" name="trabajador.curp" style={{ width: "100%" }}
                            value={trabajador.curp || ""} className={errores.curp ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="18" />
                        {errores.curp ? <div><Message severity="error" text={errores.curp} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.primerApellido" name="trabajador.primerApellido" style={{ width: "100%" }}
                            value={trabajador.primerApellido || ""} className={errores.primerApellido ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Apellido Paterno" />
                        {errores.primerApellido ? <div><Message severity="error" text={errores.primerApellido} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.segundoApellido" name="trabajador.segundoApellido" style={{ width: "100%" }}
                            value={trabajador.segundoApellido || ""} className={errores.segundoApellido ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Apellido Materno" />
                        {errores.segundoApellido ? <div><Message severity="error" text={errores.segundoApellido} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.nombre" name="trabajador.nombre" style={{ width: "100%" }}
                            value={trabajador.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Nombre(s)" />
                        {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.tipoTrabajador">*TIPO TRABAJADOR</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="trabajador.tipoTrabajador" name="trabajador.tipoTrabajador" options={tiposTrabajadores} value={trabajador.tipoTrabajador} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                        {errores.tipoTrabajador ? <div><Message severity="error" text={errores.tipoTrabajador} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.jornadaSemana">*JORNADA / SEM.</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="trabajador.jornadaSemana" name="trabajador.jornadaSemana" options={jornadas} value={trabajador.jornadaSemana} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                        {errores.jornadaSemana ? <div><Message severity="error" text={errores.jornadaSemana} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.trabajador">*TRABAJADOR PENSIONADO</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="trabajador.trabajadorPensionado" name="trabajador.trabajadorPensionado" options={tipoTrabajadorPensionados} value={trabajador.trabajadorPensionado} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                        {errores.trabajadorPensionado ? <div><Message severity="error" text={errores.trabajadorPensionado} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.salarioDiarioIntegrado">*SALARIO D INTEGRADO</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText keyfilter={DEFAULT_MASKS.money} id="trabajador.salarioDiarioIntegrado" name="trabajador.salarioDiarioIntegrado" style={{ width: "100%" }}
                            maxLength="8" value={trabajador.salarioDiarioIntegrado || ""} className={errores.salarioDiarioIntegrado ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                        />
                        {errores.salarioDiarioIntegrado ? <div><Message severity="error" text={errores.salarioDiarioIntegrado} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.claveUbicacion">CLAVE UBICACION</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.claveUbicacion" name="trabajador.claveUbicacion" style={{ width: "100%" }}
                            maxLength="17" value={trabajador.claveUbicacion || ""} className={errores.claveUbicacion ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                        />
                        {errores.claveUbicacion ? <div><Message severity="error" text={errores.claveUbicacion} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.numeroCredito">NUMERO DE CREDITO:</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText id="trabajador.numeroCredito" name="trabajador.numeroCredito" style={{ width: "100%" }}
                            maxLength="10" value={trabajador.numeroCredito || ""} className={errores.numeroCredito ? "p-error" : ""} readonly="readonly" onChange={(e) => { this.asignarValores(e, true) }}
                        />
                        {errores.numeroCredito ? <div><Message severity="error" text={errores.numeroCredito} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="trabajador.creditoSuspencion">CREDITO SUSPENSION:</label>
                    </div>
                    <div className="p-col-12 p-md-4" >
                        <InputText readonly="readonly" id="trabajador.creditoSuspension" name="trabajador.creditoSuspension" style={{ width: "100%" }}
                            maxLength="10" value={trabajador.creditoSuspension || ""} className={errores.creditoSuspension ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                        />
                        {errores.creditoSuspension ? <div><Message severity="error" text={errores.creditoSuspension} /></div> : null}
                    </div>
                </div>
                <TabView activeIndex={activeIndex} onTabChange={(e) => this.activarTabs(e.index)}>
                    <TabPanel header="DATOS AFILIATORIOS" disabled={desactivarDatosAfiliatorios}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.codigoPostal">*CODIGO POSTAL:</label>
                            </div>
                            <div className="p-col-12 p-md-4" >
                                <InputText id="trabajador.codigoPostal" name="trabajador.codigoPostal" style={{ width: "100%" }}
                                    maxLength="5" value={trabajador.codigoPostal || ""} className={errores.codigoPostal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                />
                                {errores.codigoPostal ? <div><Message severity="error" text={errores.codigoPostal} /></div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.fechaNacimiento">*FECHA NACIMIENTO:</label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Calendar id="fechaNacimiento" name="trabajador.fechaNacimiento" value={trabajador.fechaNacimiento}
                                    placeholder="* Fecha Nacimiento" onChange={(e) => this.asignarValores(e, false)}
                                    className={errores.fechaNacimiento ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                                {errores.fechaNacimiento ? <div><br /> <Message severity="error" text={errores.fechaNacimiento} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.lugarNacimiento">LUGAR DE NACIMIENTO:</label>
                            </div>
                            <div className="p-col-12 p-md-3" >
                                <Dropdown appendTo={document.body} id="trabajador.lugarNacimiento" name="trabajador.lugarNacimiento" options={lugaresNacimiento} value={trabajador.lugarNacimiento} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                                {errores.lugarNacimiento ? <div><Message severity="error" text={errores.lugarNacimiento} /></div> : null}


                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.umf">umf:</label>
                            </div>
                            <div className="p-col-12 p-md-3" >
                                <InputText id="trabajador.umf" name="trabajador.umf" style={{ width: "100%" }}
                                    maxLength="3" value={trabajador.umf || ""} className={errores.umf ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                />
                                {errores.umf ? <div><Message severity="error" text={errores.umf} /></div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.ocupacion">OCUPACION:</label>
                            </div>
                            <div className="p-col-12 p-md-3" >
                                <InputText id="trabajador.ocupacion" name="trabajador.ocupacion" style={{ width: "100%" }}
                                    maxLength="28" value={trabajador.ocupacion || ""} className={errores.ocupacion ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                />
                                {errores.ocupacion ? <div><Message severity="error" text={errores.umf} /></div> : null}
                            </div>
                            {trabajador.jornadaSemana === "Menor a 8 Horas" ?
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="trabajador.horas">*HORAS:</label>
                                </div>
                                : null}
                            {trabajador.jornadaSemana === "Menor a 8 Horas" ?
                                <div className="p-col-12 p-md-3" >
                                    <InputText maxLength="1" keyfilter={DEFAULT_MASKS.money} id="trabajador.horas" name="trabajador.horas" style={{ width: "100%" }}
                                        value={trabajador.horas || ""} className={errores.horas ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                    />
                                    {errores.horas ? <div><Message severity="error" text={errores.horas} /></div> : null}
                                </div>
                                : null}
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.sexo">*SEXO:</label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Dropdown appendTo={document.body} id="trabajador.sexo" name="trabajador.sexo" options={sexos} value={trabajador.sexo} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                                {errores.sexo ? <div><Message severity="error" text={errores.sexo} /></div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.tipoSalario">*TIPO SALARIO:</label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Dropdown appendTo={document.body} id="trabajador.tipoSalario" name="trabajador.tipoSalario" options={tiposSalarios} value={trabajador.tipoSalario} onChange={(e) => { this.validarTipoTrabajador(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                                {errores.tipoSalario ? <div><Message severity="error" text={errores.tipoSalario} /></div> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="trabajador.reporte">REPORTE:</label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Reporte" icon="pi-md-folder" onClick={this.btnReporte} />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="MOVIMIENTOS" disabled={desactivarMovimientos}>
                        <TabMovimientosTrabajadorSua ref={(el) => this.tabMovimientosTrabajadorSua = el} trabajador={trabajador} />
                    </TabPanel>
                    <TabPanel header="IMPORTAR DATOS" disabled={desactivarImportarDatos}>
                        <TabImportarDatos ref={(el) => this.tabImportarDatos = el} />
                    </TabPanel>

                </TabView>
            </div>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <Button label="Importar" icon="pi-md-import-export" disabled={desactivarBotonesImportar} onClick={this.enviarArchivo} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Actualizar" icon="pi-md-refresh" onClick={this.preActualizar} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Eliminar" icon="pi-md-delete" onClick={this.mostrarModalEliminar} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Seleccionar" icon="pi-md-check" onClick={this.obtenerResultados} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Nuevo" icon="pi-md-plus" onClick={this.btnNuevo} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Imprimir" icon="pi-md-insert-drive-file" disabled={desactivarBotonesImportar} onClick={this.btnImprimir} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Salir" icon="pi-md-close" onClick={this.btnSalir} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12 p-md-12">
                        <Dialog
                            header="Confirmación"
                            visible={mostrarModalConfirmacion}
                            modal={true}
                            appendTo={document.body}
                            footer={dialogFooterConfirmacionEliminar}
                            onHide={this.cerrarModalConfirmacion}>
                            <h2>¿Estás seguro de eliminar el trabajador?</h2>
                        </Dialog>

                        <Dialog
                            header="Guardar información"
                            visible={mostrarModalConfirmacioActualizar}
                            modal={true}
                            appendTo={document.body}
                            footer={dialogFooterConfirmacionActualizar}
                            onHide={this.cerrarModalConfirmacion}>
                            <h2>¿Desea guardar la información del trabajador?</h2>
                        </Dialog>

                        <Dialog
                            header="Actualizar Trabajadores"
                            visible={mostrarModalConfirmacionCredito}
                            modal={true}
                            appendTo={document.body}
                            footer={dialogFooterConfirmacionCredito}
                            onHide={this.cerrarModalConfirmacion}>
                            <h2>El trabajador tuvo crédito INFONAVIT. ¿Desea actualizar con estos datos el movimiento de Reidsenube de Descuento?</h2>
                        </Dialog>
                    </div>
                </div>
            </div>

            <Dialog header="Catálogo de Trabajadores" visible={mostrarCatalogoTrabajadores} modal={true}
                onHide={this.cerrarModalCatalogoTrabajadores}>
                <div className="p-col-12 p-md-3" >
                    <Dropdown placeholder="Selecciona criterio de busqueda" appendTo={document.body} id="criterio.descripcion" name="criterio.descripcion" options={criteriosOrdenamientos} value={criterio.descripcion} onChange={(e) => { this.asignarValores(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                </div>
                <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="CATALOGO DE TRABAJADORES" onRowDoubleClick={this.dobleClickRenglon} >
                    <Column field="numeroSeguridadSocial" header="NUMERO DE SEG. SOCIAL" autoLayout={true} />
                    <Column body={this.plantillaNombre} header="NOMBRE DEL ASEGURADO" autoLayout={true} />
                    <Column field="claveUbicacion" header="CLAVE DE UBICACION" autoLayout={true} />
                    <Column field="numeroCredito" header="No. CREDITO" autoLayout={true} />
                    <Column body={this.plantillaOpciones} header="Opciones" />
                </DataTable>
                <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                <div className="p-grid">
                    <br></br>
                    <br></br>
                </div>
                <div className="p-grid">

                    <div className="p-col-12 p-md-3" >
                        <InputText id="consulta.numeroSeguridadSocial" name="consulta.numeroSeguridadSocial" style={{ width: "100%" }}
                            value={consulta.numeroSeguridadSocial || ""} className={errores.numeroSeguridadSocial ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Número de seguridad" />
                        {errores.numeroSeguridadSocial ? <div><Message severity="error" text={errores.numeroSeguridadSocial} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <InputText id="consulta.nombre" name="consulta.nombre" style={{ width: "100%" }}
                            value={consulta.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Nombre" />
                        {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3" >
                        <InputText id="consulta.claveUbicacion" name="consulta.claveUbicacion" style={{ width: "100%" }}
                            value={consulta.claveUbicacion || ""} className={errores.claveUbicacion ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Clave de ubicación" />
                        {errores.claveUbicacion ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <InputText id="consulta.numeroCredito" name="consulta.numeroCredito" style={{ width: "100%" }}
                            value={consulta.numeroCredito || ""} className={errores.numeroCredito ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true, true) }}
                            placeholder="Número de credito" />
                        {errores.numeroCredito ? <div><Message severity="error" text={errores.numeroCredito} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button label="Buscar" icon="pi-md-search" onClick={this.buscarPorParametrosTrabajador} />
                    </div>
                </div>
            </Dialog>
        </div>

        );

    }
}